import React from "react";
import { PrismicRichText as PrismicRichTextReact } from "@prismicio/react";
import { htmlSerializer } from "../../utils/htmlSerializer";
import {
  SimpleCircleBase,
  Image,
  Title,
  Description,
} from "./simple-circle.styled";
import { PrismicRichTextField } from "../../types/graphql";

interface ISimpleCircleProps {
  image: string | null | undefined;
  imageAlt: string;
  title: string | null | undefined;
  description: Pick<PrismicRichTextField, "richText"> | null | undefined;
}

const SimpleCard = (props: ISimpleCircleProps) => {
  return (
    <SimpleCircleBase>
      {props.image && (
        <Image
          src={props.image}
          alt={props.imageAlt || "Xometry Illustration"}
        />
      )}
      {props.title && <Title>{props.title}</Title>}
      {props.description && (
        <Description>
          <PrismicRichTextReact
            field={props.description.richText}
            components={htmlSerializer}
          />
        </Description>
      )}
    </SimpleCircleBase>
  );
};

export default SimpleCard;
